import React, { startTransition, useEffect } from "react";
import "./styles.css";
//internal and external components/containers import
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import SearchFilterContainer from "../../containers/SearchFilterContainer";
import { setCurrentTab } from "../../redux/reducers/actionPlan";
import PerformancePlanTabs from "../../containers/PerformancePlanTabs";
import {
  actionsRegex,
  projectsRegex,
  selectedActionRegex,
  selectedProjectActionRegex,
  selectedProjectRegex,
} from "../../common/StaticExports";

const PerformancePlan = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [t] = useTranslation();

  startTransition(() => {
    var tab: any = "";
    var path = location.pathname;
    if (
      projectsRegex.test(location.pathname) ||
      selectedProjectRegex.test(location.pathname) ||
      selectedProjectActionRegex.test(location.pathname) ||
      actionsRegex.test(location.pathname) ||
      selectedActionRegex.test(location.pathname)
    ) {
      path = "/performanceplan";
    }
    switch (path) {
      case "/performanceplan":
        tab = t("ACTION_PLAN");
        dispatch(setCurrentTab(tab));
        break;
      // case '/strategy':
      //   tab = t("STRATEGY");
      //   dispatch(setCurrentTab(tab));
      //   break;
    }
  });

  return (
    <React.Fragment>
      <Box className={"contentSpacing"}>
        <Box className="headerWrapper">
          <SearchFilterContainer parent={"Performance Plan"} />
        </Box>
        <PerformancePlanTabs />
      </Box>
    </React.Fragment>
  );
};

export default PerformancePlan;
